export default __webpack_public_path__ + "static/media/button-checkbox-on.367d536a.svg";